<template>
  <v-card height="350px" class="d-flex flex-column" id="destination-card">
    <v-card-title class="primary white--text">
      <Icon
      v-if="!tractDestination.isExternal"
      icon="mdi-home"
      iconColor="tertiary"
      :small="false"
      :tooltipText="$t('internal')"
      />
      <span class="mt-1">
        {{tractDestination.destinationAccountName}}
      </span>
      <v-spacer></v-spacer>
      <span v-if="tractDestination.distance > 0">
        {{ $t('distanceInMiles', { distance: tractDestination.distance }) }}
      </span>
    </v-card-title>
    <v-card-text class="flex-grow-1" style="overflow: hidden !important;overflow-y: auto">
      <v-container fluid>
        <v-row dense>
          <v-col cols="10">
            <v-data-table
            :items="products"
            :headers="headers"
            :hide-default-footer="products.length < 10"
            dense
            >
              <template #item.scaleFrequency="{ item }">
                <span v-if="item.scaleFrequency !== null && item.scaleFrequency > 0" class="body-1">
                  {{ convertPercentToRatio(item.scaleFrequency) }}
                </span>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="2" align="right">
            <div style="position:relative;">
              <Icon
              icon="mdi-pencil"
              iconColor="success"
              :small="false"
              dataTestId="tract-destination-edit-button"
              :tooltipText="$t('edit')"
              @icon-clicked="$emit('edit-destination')"
              :disabled="!userAssignedClaim(UserClaims.ContractManager)"
              elementId="edit"/>
              <Icon
              icon="mdi-delete-forever"
              iconColor="error"
              :small="false"
              dataTestId="contract-delete-button"
              :tooltipText="$t('delete')"
              @icon-clicked="$emit('delete-destination')"
              :disabled="!userAssignedClaim(UserClaims.ContractManager)"
              elementId="delete"/>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-row dense class="mt-6">
          <Icon
          :small="false"
          icon="mdi-altimeter"
          :tooltipText="$t('contracts')"
          iconColor="info"/>
          <span class="font-weight-bold mt-1" style="font-size: 15px;">{{tractDestination.contractCount}}</span>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <Icon
            v-if="tractDestination.requiresExt2"
            icon="mdi-pound"
            :small="false"
            :tooltipText="$t('requiresExt2')"/>
          </v-col>
          <v-col cols="auto">
            <Icon
            :small="false"
            icon="mdi-plus"
            :tooltipText="$t('newContract')"
            :disabled="!userAssignedClaim(UserClaims.ContractManager)"
            @icon-clicked="openForm"
            elementId="new-contract"
            />
          </v-col>
        </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { TractDestination } from '@/model/TractDestination.js'
import { UserClaims } from '@/utils/Enumerations.js'
import { userAssignedClaim } from '@/utils/ClaimUtility.js'
export default {
  name: 'DestinationCard',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    tractDestination: {
      type: TractDestination,
      required: true
    }
  },

  data: () => ({
    UserClaims
  }),

  computed: {
    headers () {
      const headers = [
        {
          text: this.$t('product'),
          value: 'productName'
        }
      ]

      if (this.tractDestination.products.some(p => p.scaleFrequency !== null && p.scaleFrequency > 0)) {
        headers.push({
          text: this.$t('scaleFrequency'),
          value: 'scaleFrequency',
          align: 'right'
        })
      }

      return headers
    },
    products () {
      return this.tractDestination.products
    }
  },

  created () {

  },

  methods: {
    userAssignedClaim,
    convertPercentToRatio (percent) {
      const p = parseFloat(percent)
      if (!isFinite(p) || p <= 0) return ''
      const denom = Math.round(100 / p)
      return `1:${denom}`
    },
    openForm () {
      this.$emit('new-contract-pressed')
    }
  }
}
</script>
